import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p>{`The PHP Developer Guide contains information for developers who want to know more about developing or modifying Adobe Commerce and Magento Open Source components. With this knowledge you can extend or customize any of the existing components. You can also create components that introduce new functionality and distribute them to merchants.`}</p>
    <h2 {...{
      "id": "components"
    }}>{`Components`}</h2>
    <p>{`The Adobe Commerce and Magento Open Source applications are made up of `}<em parentName="p">{`Modules`}</em>{`, `}<em parentName="p">{`Themes`}</em>{`, and `}<em parentName="p">{`Language Packages`}</em>{`:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "/commerce/php/architecture/modules/overview/"
          }}><strong parentName="a">{`Modules`}</strong></a>{` interact with other parts of the application to accomplish a particular business function or provide a feature. A module can contain a user interface for displaying information or interacting with the user. It can also contain application interfaces that another module or code chunk might call.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/frontend-core/guide/themes/"
          }}><strong parentName="a">{`Themes`}</strong></a>{` provide a personalized touch for each Adobe Commerce or Magento Open Source installation by changing the look and feel of the storefront or Admin. Two themes are already available within the default code structure: Blank theme and Luma theme. Refer to these default themes when creating custom themes.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://developer.adobe.com/commerce/frontend-core/guide/translations/"
          }}><strong parentName="a">{`Language packages`}</strong></a>{` assist in internationalization(i18n) and localization by providing translations for strings that display on the storefront and Admin.`}</p>
      </li>
    </ul>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`You must follow a `}<a parentName="p" {...{
        "href": "https://www.php-fig.org/psr/psr-4/"
      }}>{`PSR-4 compliant`}</a>{` structure when building a module.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      